export default "__VITE_ASSET__Bpe2_TPG__"